
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqqUeSA4SSDXpx2SEepRELsaVPtSV9qV_NX_mB1ET2O_45MMeta } from "/codebuild/output/src4242018178/src/src/pages/faq.vue?macro=true";
import { default as menu8Q_XuETza1UxclXpYlsAJzyehCBEFVqTpG6OUUM36pkMeta } from "/codebuild/output/src4242018178/src/src/pages/menu.vue?macro=true";
import { default as index13Rl_45lTd_WFjhXjw9s_pf5EGqj9Iq3LP1L_453f4MHLfUMeta } from "/codebuild/output/src4242018178/src/src/pages/index.vue?macro=true";
import { default as contactmFlJlft2cYBDwb_XoZ1I_45881B0HKdMTnjUMfii7zSooMeta } from "/codebuild/output/src4242018178/src/src/pages/contact.vue?macro=true";
import { default as tutorialbKH44vBgXgZ3OTJKyamVbB2hD24bDRVJ36REJ9XlehwMeta } from "/codebuild/output/src4242018178/src/src/pages/tutorial.vue?macro=true";
import { default as agreementTd74E5Kn1gYroy9bgR6rDCA1ClU4Gkr7UzXeqdBh24UMeta } from "/codebuild/output/src4242018178/src/src/pages/agreement.vue?macro=true";
import { default as about_45passZy8xxXfKxrouwkym_45qMAjK_45WFTd1VyIJ1caNmrwDCWgMeta } from "/codebuild/output/src4242018178/src/src/pages/about-pass.vue?macro=true";
import { default as indexl2uq_45n1oUl4pAupSyzcqmx9ya1lo2iEOmGmz8mAloS8Meta } from "/codebuild/output/src4242018178/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93Aqe9qA7DG_vXgHvLMozjqeXg6cf_456FFHx6VGN2dH_nAMeta } from "/codebuild/output/src4242018178/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancerIODLkdPB_45UM8HaIO_Fd3dDqVdCJ_458QOc9lUQAb67z0Meta } from "/codebuild/output/src4242018178/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93hnf5RMpBY_45R4lyWynO4zeiExhzuvVAB8J6GtOq950OMMeta } from "/codebuild/output/src4242018178/src/src/pages/notice/[id].vue?macro=true";
import { default as indexgDGYVbYTQAAN5vJW91gdxjamp3Jev6YK60L_Utn3NHIMeta } from "/codebuild/output/src4242018178/src/src/pages/coupon/index.vue?macro=true";
import { default as indexYjAf4fFDPDfy_45dxBj2l6gpHsbGKRCTJbqPZoIVWmWjMMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/index.vue?macro=true";
import { default as index4xdlRjh2lEFaATpc88xyEcahrf1y1Mx_54nNkrOfrLYMeta } from "/codebuild/output/src4242018178/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93xzRoqOQcv1AawKXsbTa7XxT7H6YBp54xyij3SgJ5QZ8Meta } from "/codebuild/output/src4242018178/src/src/pages/parking/[id].vue?macro=true";
import { default as index2_45cUzTemiyL1xTfqjb9a681ed1v8NwZF3KgPxhOh9QkMeta } from "/codebuild/output/src4242018178/src/src/pages/history/index.vue?macro=true";
import { default as indexfT3E4rEAAsyJkv6w2FstmjWmUP6sBmIzizjCZMbS0TwMeta } from "/codebuild/output/src4242018178/src/src/pages/monthly/index.vue?macro=true";
import { default as index_45ZLAFpSD9nQ_W0j2KbsCv2VTUHiOu6TW11vP3mQwMSoMeta } from "/codebuild/output/src4242018178/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexDzVdMdIq27eUGnVgawCzR1pspHNFXojCyXuK9NlRvwoMeta } from "/codebuild/output/src4242018178/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviq_rtbXahJtM71YERkVSruYoUz61B5M_oxgGmAPRTWXwMeta } from "/codebuild/output/src4242018178/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit81h_459iPixIgT7m7nZDUDhlaMU_9R97T1f_45_fOjuQLSkMeta } from "/codebuild/output/src4242018178/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementY5tkaJFM48YBGSJywqY46q1frlP9v6djZC5RgSiaHPIMeta } from "/codebuild/output/src4242018178/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexzFJpludUJe0cEFHbKaoHjVQBB0TMmvOrEgel4orNFVoMeta } from "/codebuild/output/src4242018178/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dq10Q0OmqLv8foxCQCEkBnM8mHKJ2By0WaJ1KJ4vemYgMeta } from "/codebuild/output/src4242018178/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmSUK3z7hBwP2xoWmaQ6d2RsOBkOW8AcIRzev1dBlNbD0Meta } from "/codebuild/output/src4242018178/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexr51AKdUgliSWCUbeRGyaeT8J9Gk5TT82bxHYPYvWTGkMeta } from "/codebuild/output/src4242018178/src/src/pages/card/create/index.vue?macro=true";
import { default as indexd2yijBLvwuvZUHN1yEVsz5W1nYCoiKjeQJ7rE6VJ_24Meta } from "/codebuild/output/src4242018178/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmCjjSLs0UDCBWXQWdoj19ZHKXabZaxLZsifj4Lnt2LT0Meta } from "/codebuild/output/src4242018178/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmffQ7C32ah33NBwav0bFwtOlTZBxPvUn0B2u_dMeS9O8Meta } from "/codebuild/output/src4242018178/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeAynYb7NPVILDIH92tYtTKc70xdb9uDKKnuKWtG0f8GEMeta } from "/codebuild/output/src4242018178/src/src/pages/membership/complete.vue?macro=true";
import { default as registerjOI_45ALPO5vsbv_45q744YNP2zu2N1ZNBIpbGxzQCYlT7EMeta } from "/codebuild/output/src4242018178/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93WI4AvaijzzbOeZOsIlCTVgwaX6tSpjXW0aVYtF54hwQMeta } from "/codebuild/output/src4242018178/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmx4nDWR6IV5Pd3zRUZ5253r_45WkZmbVgMILa2TffaZc0UMeta } from "/codebuild/output/src4242018178/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93rz1M6ut9FImEnLCF6NyQ6KIsRYpLnyCWmxFnMigEF50Meta } from "/codebuild/output/src4242018178/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexmkFr3RIyQvuoW0RyDkqKdNp6VC11HpuBRMzZJXHzDyoMeta } from "/codebuild/output/src4242018178/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45code_45vRX97h99fECffPBHHTCvyJS44_c7C6kyyA6sO42qCcMeta } from "/codebuild/output/src4242018178/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codepa9Lexi_zIs8ipC9jv8AD39_45ToSmxkFdD8kbkhsAzjEMeta } from "/codebuild/output/src4242018178/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as complete8dlEM0MJGNOxNPXZpjy9gr_45ikMBx4trYOqe0yZNoEEAMeta } from "/codebuild/output/src4242018178/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerAWIsV5_45Zi54wFHQ10XdqFaFy3fMg0Gccjyxlz6XePosMeta } from "/codebuild/output/src4242018178/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete9QBd_J_45NrtfyjgIpA6K2JiLSt2gW7JX4snVfNs0UY0oMeta } from "/codebuild/output/src4242018178/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index1Qo7tpmdQOi5JWtx2hshWIO_4502UuHNtzxthz5BPKsZQMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmThtH_ACIL7fujXy_mMyhi4jhsC5kUOnP97W5uQ8lrZEMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completezfhJ5DIBL9uxO5Cx2ydW7U3Eqtz8dooIOolObZu4qAkMeta } from "/codebuild/output/src4242018178/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexdQnrXP_45Y_l0fqYXf8F4apnPTMI0S2YqqYB5Ab7tAlPcMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93uNIrpUCICrWiBoNpfDMgurQTpNmg18Kpq5hZRaeiP8YMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completezYp8_45y_45cdbDXWMlwMWzoCeBZeTnyDlsfP1VR7ofluhQMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasE0IzuQFZgcmouSv9z5W4Yw8uXZ3BT676_45hvEI2rEbMcMeta } from "/codebuild/output/src4242018178/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample66g_45lIOlLZJkdRWxH1Ftkz65aW_XaRKSZ72zndEDR9UMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailfeUkSEjg8au2zRCVp0h_SVrNB7P1wdN5NPtSyAYuTBsMeta } from "/codebuild/output/src4242018178/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmT9l_45KBV4w__45IBy3jOsPyQi3QRW_45YmRwmlK66ipTrWncMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent9sZwN0HKBCGNVRb6V3aqh6trPdzlH_YhuJ7Cw_f6HdgMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm_45pfuyUf8GNCWI6jibvcVynxfn4p9Vpen2qM4moTkBMsMeta } from "/codebuild/output/src4242018178/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateDFyPgP_45bNNQledkelDdN2OAi8OiHpjA_ZomSdNwRP_IMeta } from "/codebuild/output/src4242018178/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete0EnHtpoUhwHCHAxjD9WyuiBEr_dAtFRKhs0l0i5Jbd0Meta } from "/codebuild/output/src4242018178/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45coderQk3erWdp8Cq02XIA_45pKXWOXkGFfsF7g1FcVR4QPpN0Meta } from "/codebuild/output/src4242018178/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordhccrOINxcBCnkfOpa_IuylXJghJLJfXfjgHWhMpkMCoMeta } from "/codebuild/output/src4242018178/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasMJkzvxQzFDLvI1KkgkORBR9EJKZvXL8Ga70pTdSFbZ8Meta } from "/codebuild/output/src4242018178/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerbAkO4D5GUFeZvQ_0k6DDGrJg1KkgLZM6UEBI0AxwvTEMeta } from "/codebuild/output/src4242018178/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeDk5WVIGF72Psgfm2JQscTfObk_y7Hvgkj3a3KYeOVzYMeta } from "/codebuild/output/src4242018178/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index2MGhNV_45RKSDubnLGkKmZON0uHUU_yc9nHcy04OCxoWkMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexmJNptbinBjFb5_456Le1pRM35S7PTnK5d2BdIIG_w4_45mUMeta } from "/codebuild/output/src4242018178/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexijJrGlu_7_45OYM8Xu9uj3MPYQRct2hFbCuGIcnXfv7bAMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexlBcdlYS7rRvHx9Nye5gRkUQQ2fPhyBYAnjmtbkCkGKUMeta } from "/codebuild/output/src4242018178/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateiQWJMG1X_45U9dmfvImDLX65NBmXokK5J9KxK6em_45ubI8Meta } from "/codebuild/output/src4242018178/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completea9zb9EUUBIR9hglC5NSGkj6_dUeYN_VAW_45NnPyWa_NYMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmTpkS_W_45cmU6L_45Xw1Gj45cPa1ve9KhuJzAN3GB0iIlZAMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as index58eOpxVhjXJTboP1TO5OjoCW46QeWJcupe_452lTztvSgMeta } from "/codebuild/output/src4242018178/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completetRjW0c_45WfHz8Qc047enymxjwvqFHuq99xVs1qYLeAWcMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateBON1DSvnkHp63GhZ6gCOqBAQ_45MD4BCJ5QOJSa7k7kAAMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index2K9NnKzbG65g0gMWzi6bYUewmXbwMWEoBu_OwLi_VwUMeta } from "/codebuild/output/src4242018178/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexTGOkLJWYvhhKm6gQWPBGk_aV9nmd_4535D47mw4n9NAsoMeta } from "/codebuild/output/src4242018178/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completewgwgpf8rVRLq_X6XzijNYaMQ2ZF0N0cErW4RowLTlewMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index7p8D0LXi__45eiWnynIPYXNjBUQzzCF0My5V4RHwCyjNsMeta } from "/codebuild/output/src4242018178/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeenLZKXnvYXokXEEbHpoIvTOAr5tORqKikY3L2cHkXLUMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexfRIFlCpH9oO_45k_cqqb09CcfkiJh2Kohm7g1edCupmZcMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexIv0j6a5W0o95Fin6_b4Z_45kH8rpZ5u80TB6hyJgI81BcMeta } from "/codebuild/output/src4242018178/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexnfvStteUaAxBKlvqZc356V__nXZS2KvboljY4r2ERwEMeta } from "/codebuild/output/src4242018178/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatedxgBOw2BOvk1leN0_OTmL36JYhy2n6nypVvXFX2UXmMMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmrvgzt85CrHWOr6U546nSuETzqaLvvYVUBwOt5mf4BPAMeta } from "/codebuild/output/src4242018178/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu8Q_XuETza1UxclXpYlsAJzyehCBEFVqTpG6OUUM36pkMeta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index13Rl_45lTd_WFjhXjw9s_pf5EGqj9Iq3LP1L_453f4MHLfUMeta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexgDGYVbYTQAAN5vJW91gdxjamp3Jev6YK60L_Utn3NHIMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src4242018178/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index2_45cUzTemiyL1xTfqjb9a681ed1v8NwZF3KgPxhOh9QkMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src4242018178/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index_45ZLAFpSD9nQ_W0j2KbsCv2VTUHiOu6TW11vP3mQwMSoMeta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexDzVdMdIq27eUGnVgawCzR1pspHNFXojCyXuK9NlRvwoMeta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexr51AKdUgliSWCUbeRGyaeT8J9Gk5TT82bxHYPYvWTGkMeta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmCjjSLs0UDCBWXQWdoj19ZHKXabZaxLZsifj4Lnt2LT0Meta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmffQ7C32ah33NBwav0bFwtOlTZBxPvUn0B2u_dMeS9O8Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src4242018178/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeAynYb7NPVILDIH92tYtTKc70xdb9uDKKnuKWtG0f8GEMeta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerjOI_45ALPO5vsbv_45q744YNP2zu2N1ZNBIpbGxzQCYlT7EMeta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmx4nDWR6IV5Pd3zRUZ5253r_45WkZmbVgMILa2TffaZc0UMeta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45code_45vRX97h99fECffPBHHTCvyJS44_c7C6kyyA6sO42qCcMeta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codepa9Lexi_zIs8ipC9jv8AD39_45ToSmxkFdD8kbkhsAzjEMeta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: complete8dlEM0MJGNOxNPXZpjy9gr_45ikMBx4trYOqe0yZNoEEAMeta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerAWIsV5_45Zi54wFHQ10XdqFaFy3fMg0Gccjyxlz6XePosMeta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmThtH_ACIL7fujXy_mMyhi4jhsC5kUOnP97W5uQ8lrZEMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completezfhJ5DIBL9uxO5Cx2ydW7U3Eqtz8dooIOolObZu4qAkMeta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexdQnrXP_45Y_l0fqYXf8F4apnPTMI0S2YqqYB5Ab7tAlPcMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completezYp8_45y_45cdbDXWMlwMWzoCeBZeTnyDlsfP1VR7ofluhQMeta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample66g_45lIOlLZJkdRWxH1Ftkz65aW_XaRKSZ72zndEDR9UMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailfeUkSEjg8au2zRCVp0h_SVrNB7P1wdN5NPtSyAYuTBsMeta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmT9l_45KBV4w__45IBy3jOsPyQi3QRW_45YmRwmlK66ipTrWncMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent9sZwN0HKBCGNVRb6V3aqh6trPdzlH_YhuJ7Cw_f6HdgMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm_45pfuyUf8GNCWI6jibvcVynxfn4p9Vpen2qM4moTkBMsMeta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete0EnHtpoUhwHCHAxjD9WyuiBEr_dAtFRKhs0l0i5Jbd0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45coderQk3erWdp8Cq02XIA_45pKXWOXkGFfsF7g1FcVR4QPpN0Meta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordhccrOINxcBCnkfOpa_IuylXJghJLJfXfjgHWhMpkMCoMeta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerbAkO4D5GUFeZvQ_0k6DDGrJg1KkgLZM6UEBI0AxwvTEMeta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeDk5WVIGF72Psgfm2JQscTfObk_y7Hvgkj3a3KYeOVzYMeta || {},
    component: () => import("/codebuild/output/src4242018178/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src4242018178/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]